import { Button, Flex } from "antd";
import styled from "styled-components";

export const StyledDeleteFileButton = styled(Button)`
    && {
        width: 20px;
        height: 20px;
    }
`;

export const StyledContainer = styled(Flex)`
    margin-bottom: 24px;
`;
